export const card = {
    position: 'relative',
    background: 'linear-gradient(180deg, rgba(255,255,255,0.04) 0%, rgba(255,255,255,0.015) 100%)',
    border: '1px solid rgba(187, 188, 188, 0.12)',
    borderRadius: '22px',
    p: { xs: 2, md: 2.5 },
    display: 'flex',
    flexDirection: 'column',
    gap: 1.5,
    transition: 'transform 0.25s ease, border-color 0.25s ease, box-shadow 0.35s ease',
    '&:hover': {
        transform: 'translateY(-3px)',
        borderColor: 'rgba(0, 215, 255, 0.35)',
        boxShadow: '0 24px 48px -22px rgba(0, 215, 255, 0.35)',
    },
};

export const header = {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 1.5,
};

export const logo = {
    height: 48,
    width: 48,
    borderRadius: '12px',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    objectFit: 'cover',
};

export const logoInitial = {
    fontSize: '1.25rem',
    fontWeight: 700,
    color: '#fff',
};

export const publisherInfo = {
    minWidth: 0,
    flex: 1,
};

export const publisherName = {
    fontWeight: 600,
    color: 'var(--ecal-white)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: '16px',       // fix 6 — was 15px (0.9375rem)
};

// Single line, no wrap — VirtuosoGrid measures each card's height once and
// reuses it; letting these wrap to extra lines on longer content makes cards
// render at inconsistent heights, which is what caused the scroll position
// to jump/oscillate while virtualized.
export const categories = {
    display: 'flex',
    flexWrap: 'nowrap',
    overflow: 'hidden',
    gap: 0.5,
    mt: 0.5,
    height: '18px',
};

export const category = {
    fontSize: '0.6875rem',
    color: 'var(--ecal-lightgrey)',
};

export const shareButton = {
    p: '5px',               // fix 7 — was 6px (0.75), reduces 30→28px
    minWidth: 0,
    color: 'var(--ecal-lightgrey)',
    borderRadius: '8px',
    '&:hover': {
        color: 'var(--ecal-white)',
        background: 'rgba(255,255,255,0.05)',
    },
};

export const pills = {
    display: 'flex',
    flexWrap: 'nowrap',
    overflow: 'hidden',
    alignItems: 'center',
    gap: 1,
    height: '24px',
};

const pillBase = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 0.5,
    padding: '3px 9px',     // fix 4 & 5 — was 2px 6px (px:0.75 py:0.25)
    borderRadius: '999px',
    fontSize: '0.72rem',
    fontWeight: 600,
    letterSpacing: '0.02em',
};

export const pillHot = {
    ...pillBase,
    background: 'linear-gradient(90deg, #FFDF10, #FF4D00)',
    color: '#1a0a00',
};

export const timezone = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 0.5,
    fontSize: '0.6875rem',
    color: 'var(--ecal-midgrey)',
};

export const nextEvent = {
    mt: 0.5,
    minHeight: '20px',
};

export const nextEventLabel = {
    fontSize: '0.6875rem',
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    color: 'var(--ecal-lightgrey)',
};

export const nextEventTitle = {
    fontSize: '0.875rem',
    fontWeight: 500,
    color: 'var(--ecal-white)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    mt: 0.25,
};

export const countdown = {
    fontSize: '0.72rem',
    color: 'var(--ecal-lightblue)',
    mt: 0.25,
};

export const syncButton = {
    mt: 0.5,
    width: '100%',
    fontSize: '16px',       // fix 3 — was 14px
    fontWeight: 400,        // fix 3 — was 600 (bold)
};
